// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BtnPoubelle_wrapper__uN11y","picto":"BtnPoubelle_picto__14E-C"};